module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0ff20e4e8ba2ba2ed8a7095b99add518.gif";